import { render } from "./CarrierCard.vue?vue&type=template&id=7b74423a&scoped=true&ts=true"
import script from "./CarrierCard.vue?vue&type=script&lang=ts"
export * from "./CarrierCard.vue?vue&type=script&lang=ts"

import "./CarrierCard.vue?vue&type=style&index=0&id=7b74423a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b74423a"]])

export default __exports__